import {
	AfterViewInit,
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	ElementRef,
	OnInit,
	Renderer2,
	ViewChild
} from '@angular/core';
import { filter } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import * as objectPath from 'object-path';
// Layout
import { LayoutConfigService, MenuAsideService, MenuOptions, OffcanvasOptions } from '../../../core/_base/layout';
import { HtmlClassService } from '../html-class.service';
import { MatIconModule, MatIconRegistry } from "@angular/material/icon";
import { HttpClientModule } from "@angular/common/http";
import { DomSanitizer } from '@angular/platform-browser';
// RxJS
import { Subject,BehaviorSubject } from 'rxjs';
@Component({
	selector: 'kt-aside-left',
	templateUrl: './aside-left.component.html',
	styleUrls: ['./aside-left.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class AsideLeftComponent implements OnInit, AfterViewInit {
	user_name:any;
	user_role:any;
	role_id:any;
	role_name:any;

	@ViewChild('asideMenu', {static: true}) asideMenu: ElementRef;

	currentRouteUrl: string = '';
	insideTm: any;
	outsideTm: any;
	userclicked:boolean;

	menuCanvasOptions: OffcanvasOptions = {
		baseClass: 'kt-aside',
		overlay: true,
		closeBy: 'kt_aside_close_btn',
		toggleBy: {
			target: 'kt_aside_mobile_toggler',
			state: 'kt-header-mobile__toolbar-toggler--active'
		}
	};

	menuOptions: MenuOptions = {
		// vertical scroll
		scroll: null,

		// submenu setup
		submenu: {
			desktop: {
				// by default the menu mode set to accordion in desktop mode
				default: 'dropdown',
			},
			tablet: 'accordion', // menu set to accordion in tablet mode
			mobile: 'accordion' // menu set to accordion in mobile mode
		},

		// accordion setup
		accordion: {
			expandAll: false // allow having multiple expanded accordions in the menu
		}
	};
	listOfIcons: any[];
	asideMenus: string;
	menuList$: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);

	count = 0; // Counter to restrict multiple trigger of mouse over event

	/**
	 * Component Conctructor
	 *
	 * @param htmlClassService: HtmlClassService
	 * @param menuAsideService
	 * @param layoutConfigService: LayouConfigService
	 * @param router: Router
	 * @param render: Renderer2
	 * @param cdr: ChangeDetectorRef
	 */
	constructor(
		public htmlClassService: HtmlClassService,
		public menuAsideService: MenuAsideService,
		public layoutConfigService: LayoutConfigService,
		private router: Router,
		private render: Renderer2,
		private cdr: ChangeDetectorRef,
		private matIconRegistry: MatIconRegistry,
		private domSanitizer: DomSanitizer
	) {
		this.role_name = localStorage.getItem('pro_role_name');
		
		}

	ngAfterViewInit(): void {
	}

	ngOnInit() {
		
		this.currentRouteUrl = this.router.url.split(/[?#]/)[0];
		this.user_name=localStorage.getItem('pro_user_name');
		this.user_role=localStorage.getItem('pro_user_role');
		// this.role_id = localStorage.getItem('role_id');
		// if(this.role_id==2){
		// 	this.router.navigate(["/maindashboard"]);
		// }
		// else if(this.role_id==5){
		// 	this.router.navigate(["/maindashboard"]);
		// }
		this.router.events
			.pipe(filter(event => event instanceof NavigationEnd))
			.subscribe(event => {
				this.currentRouteUrl = this.router.url.split(/[?#]/)[0];
				this.cdr.markForCheck();
			});

		const config = this.layoutConfigService.getConfig();
		if (objectPath.get(config, 'aside.menu.dropdown')) {
			this.render.setAttribute(this.asideMenu.nativeElement, 'data-ktmenu-dropdown', '1');
			// tslint:disable-next-line:max-line-length
			this.render.setAttribute(this.asideMenu.nativeElement, 'data-ktmenu-dropdown-timeout', objectPath.get(config, 'aside.menu.submenu.dropdown.hover-timeout'));
		}
		// this.listOfIcons =[];
		this.listOfIcons = [
			{"name":"dash","url":'./assets/media/icons/svg/Users/dashboardservicedesk.svg'},
			{"name":"dashcolor","url":'./assets/media/icons/svg/Users/dashboardservicecoloured.svg'},
			{"name":"raisecolored","url":'./assets/media/icons/svg/Users/RaiseTicket.svg'},
			{"name":"raise","url":'./assets/media/icons/svg/Users/Raiseticketwhite.svg'},
			{"name":"new","url":'assets/media/icons/svg/Users/NewTicket.svg'},
			{"name":"newcolor","url":'assets/media/icons/svg/Users/NewTicketcolored.svg'},
			{"name":"deffered","url":"assets/media/icons/svg/Users/Deffered.svg"},
			{"name":"defferedcolor","url":"assets/media/icons/svg/Users/DefferedTicket.svg"},
			{"name":"summary","url":"assets/media/icons/svg/Users/TicketSummaryColoured.svg"},
			{"name":"summaryselect","url":"assets/media/icons/svg/Users/TicketSummary.svg"},
			{"name":"customer","url":"assets/media/icons/svg/Users/Customer.svg"},
			{"name":"customercolored","url":"assets/media/icons/svg/Users/Customercolored.svg"},
			{"name":"RejectedTicket","url":"assets/media/icons/svg/Users/RejectedTicket.svg"},
			{"name":"RejectedTicketcolored","url":"assets/media/icons/svg/Users/Rejected.svg"},
			{"name":"OngoingTicket","url":"assets/media/icons/svg/Users/OngoingTicket.svg"},
			{"name":"OngoingTicketcolored","url":"assets/media/icons/svg/Users/ongoingticketcolored.svg"},
			{"name":"Completed","url":"assets/media/icons/svg/Users/Completed.svg"},
			{"name":"Completedcolored","url":"assets/media/icons/svg/Users/completedsercolored.svg"},
			{"name":"ContractRenewal","url":"assets/media/icons/svg/Users/ContractRenewal.svg"},
			{"name":"ImprestSpare", "url":"assets/media/icons/svg/Users/imprestspare.svg"},
			{"name": "ImprestSpareColored", "url":"assets/media/icons/svg/Users/imprestsparecolored.svg"},
			{"name": "ServiceReport", "url":"assets/media/icons/svg/Users/servicereport.svg"}, 
			{"name": "ServiceReportColored", "url":"assets/media/icons/svg/Users/servicereportcolored.svg"},
			{"name": "KBwhite", "url":"assets/media/icons/svg/Users/kbwhite.svg"},
			{"name": "KBcolored", "url":"assets/media/icons/svg/Users/kbcolored.svg"},
			{"name": "TrainingColored", "url":"assets/media/icons/svg/Users/T&AColoured.svg"},
			{"name":"TicketfortheDaytrcselected","url":"assets/media/icons/svg/Users/TicketfortheDaytrcselected.svg"},
			{"name":"Ticketforthedaytrcun","url":"assets/media/icons/svg/Users/Ticketforthedaytrcun.svg"},
			{"name":"ImprestComponentstrc","url":"assets/media/icons/svg/Users/ImprestComponentstrc.svg"},
			{"name":"ImprestComponentstrcsle","url":"assets/media/icons/svg/Users/ImprestComponentstrcsle.svg"},
			{"name":"QualityCheckuncolored","url":"assets/media/icons/svg/Users/QualityCheckuncolored.svg"},
			{"name":"QualityCheckcolored","url":"assets/media/icons/svg/Users/QualityCheckcolored.svg"},
			{"name":"ComponentsInventorycol","url":"assets/media/icons/svg/Users/ComponentsInventorycol.svg"},
			{"name":"ComponentsRequestcol","url":"assets/media/icons/svg/Users/ComponentsRequestcol.svg"},
			{"name":"ComponentsInventoryuncol","url":"assets/media/icons/svg/Users/ComponentsInventoryuncol.svg"},
			{"name":"ComponentsRequestunc","url":"assets/media/icons/svg/Users/ComponentsRequestunc.svg"},
			{"name":"componentstockManagementUnSelected","url":"assets/media/icons/svg/Users/componentstockManagementUnSelected.svg"},
			{"name":"componentUpdateInventoryUnselected","url":"assets/media/icons/svg/Users/componentUpdateInventoryUnselected.svg"},
			{"name":"componentUpdateInventorySeleced","url":"assets/media/icons/svg/Users/componentUpdateInventorySeleced.svg"},
			{"name":"componentStockManagementSelected","url":"assets/media/icons/svg/Users/componentStockManagementSelected.svg"}
		]
		this.listOfIcons.forEach(icon => {
			this.matIconRegistry.addSvgIcon(icon.name,
			this.domSanitizer.bypassSecurityTrustResourceUrl(icon.url));
		});
	}


	changeIcon(iconName: string): void {
		// Retrieve the menu configuration from localStorage
		const asideMenusJSON = localStorage.getItem('pro_asideMenus');
		if (!asideMenusJSON) {
		  return; // Handle the case when asideMenus is not available in localStorage
		}
	  
		const asideMenus: any[] = JSON.parse(asideMenusJSON);
		// Find the menu item with the given page name
		asideMenus.forEach(item => {
			if (item.page == iconName){
				 // Update the selected and icon properties based on the selected state
				item.selected = !item.selected;
			}
			else{
				 // Handle the case when the menu item is not found
				item.selected = false;
			}
		  });

		// Update the menu configuration in localStorage
		  this.menuAsideService.menuList$.next(asideMenus);
		localStorage.setItem('pro_asideMenus', JSON.stringify(asideMenus));
	}	  
	/**
	 * Check Menu is active
	 * @param item: any
	 */
	isMenuItemIsActive(item): boolean {
		if (item.submenu) {
			return this.isMenuRootItemIsActive(item);
		}

		if (!item.page) {
			return false;
		}

		return this.currentRouteUrl.indexOf(item.page) !== -1;
	}

	/**
	 * Check Menu Root Item is active
	 * @param item: any
	 */
	isMenuRootItemIsActive(item): boolean {
		let result: boolean = false;

		for (const subItem of item.submenu) {
			result = this.isMenuItemIsActive(subItem);
			if (result) {
				return true;
			}
		}

		return false;
	}

	/**
	 * Use for fixed left aside menu, to show menu on mouseenter event.
	 * @param e Event
	 */
	mouseEnter(e: Event) {
		// check if the left aside menu is fixed
		if (document.body.classList.contains('kt-aside--fixed')) {
			if (this.outsideTm) {
				clearTimeout(this.outsideTm);
				this.outsideTm = null;
			}

			this.insideTm = setTimeout(() => {
				// if the left aside menu is minimized
				if (document.body.classList.contains('kt-aside--minimize') && KTUtil.isInResponsiveRange('desktop')) {
					// show the left aside menu
					this.render.removeClass(document.body, 'kt-aside--minimize');
					this.render.addClass(document.body, 'kt-aside--minimize-hover');
				}
			}, 50);
		}
	}

	/**
	 * Use for fixed left aside menu, to show menu on mouseenter event.
	 * @param e Event
	 */
	mouseLeave(e: Event) {
		if (document.body.classList.contains('kt-aside--fixed')) {
			if (this.insideTm) {
				clearTimeout(this.insideTm);
				this.insideTm = null;
			}

			this.outsideTm = setTimeout(() => {
				// if the left aside menu is expand
				if (document.body.classList.contains('kt-aside--minimize-hover') && KTUtil.isInResponsiveRange('desktop')) {
					// hide back the left aside menu
					this.render.removeClass(document.body, 'kt-aside--minimize-hover');
					this.render.addClass(document.body, 'kt-aside--minimize');
				}
			}, 100);
		}
	}

	/**
	 * Returns Submenu CSS Class Name
	 * @param item: any
	 */
	getItemCssClasses(item) {
		let classes = 'kt-menu__item';

		if (objectPath.get(item, 'submenu')) {
			classes += ' kt-menu__item--submenu';
		}

		if (!item.submenu && this.isMenuItemIsActive(item)) {
			classes += ' kt-menu__item--active kt-menu__item--here';
		}

		if (item.submenu && this.isMenuItemIsActive(item)) {
			classes += ' kt-menu__item--open kt-menu__item--here';
		}

		// custom class for menu item
		const customClass = objectPath.get(item, 'custom-class');
		if (customClass) {
			classes += ' ' + customClass;
		}

		if (objectPath.get(item, 'icon-only')) {
			classes += ' kt-menu__item--icon-only';
		}

		return classes;
	}

	getItemAttrSubmenuToggle(item) {
		let toggle = 'hover';
		if (objectPath.get(item, 'toggle') === 'click') {
			toggle = 'click';
		} else if (objectPath.get(item, 'submenu.type') === 'tabs') {
			toggle = 'tabs';
		} else {
			// submenu toggle default to 'hover'
		}

		return toggle;
	}

	disableScroll() {
		return this.layoutConfigService.getConfig('aside.menu.dropdown') || false;
	}
	//profile and change password toggle
	opendropdown(){
		document.getElementById("sub-dropdown").classList.toggle("show"); //profile and change password show and hide
		this.userclicked = !this.userclicked; //arrow toggle
	}

	hoverIn(iconName:string, event): void {
		if(this.count == 0) { // Only allow code to be executed first time the event is triggered. Else stop propogation
			// Retrieve the menu configuration from localStorage
			const asideMenusJSON = localStorage.getItem('pro_asideMenus');
			if (!asideMenusJSON) {
			  return; // Handle the case when asideMenus is not available in localStorage
			}
		  
			const asideMenus: any[] = JSON.parse(asideMenusJSON);
			// Find the menu item with the given page name
			asideMenus.forEach(item => {
				if (item.page == iconName  || item.page == this.currentRouteUrl){
					 // Update the selected and icon properties based on the selected state
					item.selected = true;
				}
				else{
					// if(this.currentRouteUrl != item.page) {
						item.selected = false;
					// }
				}
			  });
			// Update the menu configuration in localStorage
			  this.menuAsideService.menuList$.next(asideMenus);
			localStorage.setItem('pro_asideMenus', JSON.stringify(asideMenus));
			this.count++;
		} else {
			event.stopPropagation();
      		event.preventDefault();
		}
	  }
	  
	  hoverOut(iconName:string): void {
		  this.count = 0; // Reset counter when mouse leave
		// Retrieve the menu configuration from localStorage
		const asideMenusJSON = localStorage.getItem('pro_asideMenus');
		if (!asideMenusJSON) {
		  return; // Handle the case when asideMenus is not available in localStorage
		}
	  
		const asideMenus: any[] = JSON.parse(asideMenusJSON);
		// Find the menu item with the given page name
		asideMenus.forEach(item => {
			if ((item.page == iconName) && (item.page != this.currentRouteUrl)){
				 // Update the selected and icon properties based on the selected state
				item.selected = false;
			}
		  });

		// Update the menu configuration in localStorage
		  this.menuAsideService.menuList$.next(asideMenus);
		localStorage.setItem('pro_asideMenus', JSON.stringify(asideMenus));
	  }
}
